module.exports = __webpack_public_path__ + "img/Passcard.2befc0b6.jpg";